import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as api from "@/services/api";

export const Status = {
  IDLE: "Idle",
  UPLOADING: "Uploading",
  WAITING: "Waiting",
  SUCCESS: "Succcess",
  ERROR: "Error",
};

export const uploadFile = createAsyncThunk(
  "config/uploadFile",
  async ({ fileName, file }) => {
    const response = await api.create(`/pdf`, { file });
    return {
      response,
      fileName,
    };
  }
);

const initialState = {
  status: Status.IDLE,
  apiResponse: "",
};

const slice = createSlice({
  name: "visura",
  initialState,
  reducers: {
    setStatus(state, action) {
      const { status } = action.payload;
      state.status = status;
    },
    clearStatus(state, action) {
      state.status = Status.IDLE;
      state.lastFileName = "";
      state.apiResponse = "";
    },
  },
  extraReducers: {
    [uploadFile.pending](state) {
      state.status = Status.WAITING;
    },
    [uploadFile.fulfilled](state, action) {
      const { response, fileName } = action.payload;
      state.status = Status.SUCCESS;
      state.lastFileName = fileName;
      state.apiResponse = response.values;
    },
    [uploadFile.rejected](state, action) {
      state.status = Status.ERROR;
    },
  },
});

export const selectStatus = (state) => state.visura.status;
export const selectLastFileName = (state) => state.visura.lastFileName;
export const selectApiResponse = (state) => state.visura.apiResponse;
export const { setStatus, clearStatus } = slice.actions;

export default slice.reducer;
